export default {
  computed: {
    /**
     * Displays the number of items starting from in the 'showing' section next to pagination.
     */
    showingFrom () {
      if (this.totalRows === 0) {
        return 0
      } else if (this.currentPage === 1) {
        return 1
      }

      return ((this.currentPage - 1) * this.perPage) + 1
    }
  }
}
